import React from 'react';

import Typography from '../../../../../../library/typography/typography';
import FoundItLowerButton from '../../../../../../components/found-it-lower-button/found-it-lower-button';
import MinimumPriceMessage from '../../../../../../components/minimum-price-message/minimum-price-message';
import ProductDescription from '../../../../../../components/product-description/product-description';
import ProductQuantity from '../../../../../../components/product-quantity/product-quantity';
import QuantityDisclaimer from '../../../../../../components/quantity-disclaimer/quantity-disclaimer';
import ProductListCardPrice from '../../../product-list-card-price/product-list-card-price.one-dt';

import {
  getNormalizedProductType,
  getShouldShowMinimumPriceMessage
} from '../../../../../../shared/utils/product/product';

import { ProductData } from '../../../../../../shared/types/graphql-types';

import './product-list-staggered-card-axle.one-dt.scss';

interface ProductListStaggeredCardAxleProps {
  defaultQuantity?: number;
  label: string;
  onQuantityChange: (e: Event, number) => void;
  product: ProductData;
  quantity: number;
  totalQuantity: number;
}

function ProductListStaggeredCardAxle(
  props: ProductListStaggeredCardAxleProps
) {
  const {
    defaultQuantity = 2,
    label,
    onQuantityChange,
    product,
    quantity,
    totalQuantity
  } = props;

  const { mapDisplayRule, size } = product || {};

  const productType = getNormalizedProductType(product?.productType);

  const showMinimumPriceMessage = getShouldShowMinimumPriceMessage(product);

  return (
    <div styleName="container">
      <Typography styleName="label" tag="span">
        {label}:&nbsp; <ProductDescription size={size} />
      </Typography>

      <div styleName="price-qty-container">
        <div styleName="price-container">
          <ProductListCardPrice
            hideFoundItLower
            hidePercentageSaved
            product={product}
            quantity={quantity}
            totalQuantity={totalQuantity}
          />
        </div>

        <ProductQuantity
          defaultValue={defaultQuantity}
          id="quantity"
          isHorizontal
          max={2}
          onBlur={onQuantityChange}
          onChange={onQuantityChange}
          showLabel
          value={quantity}
        />
      </div>
      <FoundItLowerButton
        productItem={{
          product: product,
          quantity: quantity,
          totalQuantity: totalQuantity
        }}
      />
      {showMinimumPriceMessage && (
        <MinimumPriceMessage message={mapDisplayRule?.message} />
      )}
      <QuantityDisclaimer
        productType={productType}
        quantity={quantity}
        styleName="quantity-disclaimer"
      />
    </div>
  );
}

export default ProductListStaggeredCardAxle;
